import { render, staticRenderFns } from "./BfTable.vue?vue&type=template&id=fb62dfe4&"
import script from "./BfTable.vue?vue&type=script&lang=js&"
export * from "./BfTable.vue?vue&type=script&lang=js&"
import style0 from "./BfTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports